var app = angular.module('leonardo');

var ReportingDashboardCtrl = function($scope) {
  var vm = this;
  vm.fullHeight = true;
  vm.params = { width: '100%', height: '100%' };
};

app.controller('ReportingDashboardCtrl', ['$scope', ReportingDashboardCtrl]);
